module.exports = __webpack_public_path__ + "static/box-cb2a86b648dbf12702b75532dd356b79.gif";